module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"defaultMessage":"Enter message to see preview..."}}')
  delete Component.options._Ctor
}
